import { render, staticRenderFns } from "./pieGroupedByValues.vue?vue&type=template&id=7e31a1fc"
import script from "./pieGroupedByValues.vue?vue&type=script&lang=ts"
export * from "./pieGroupedByValues.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
